import React from "react";

import FieldRAG_Icon from "../rag-icon";

export default function FieldRAG_FormValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                <FieldRAG_Icon className="fl-ac" option={props.option}/>
            </div>
            {props.children}
        </React.Fragment>
    );
}